var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowSmallRight = function SvgArrowSmallRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 6a2 2 0 0 0-1.4.59l-4.3 4.29a1 1 0 1 0 1.42 1.41L11 9v10a1 1 0 1 0 2 0V9l3.29 3.29a1 1 0 1 0 1.42-1.41l-4.3-4.29A2 2 0 0 0 12 6"
  })));
};
export default SvgArrowSmallRight;